/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_ActiveInputs */

const vi_packaging_material_active = /** @type {(inputs: Packaging_Material_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang sử dụng`)
};

/**

* @param {Packaging_Material_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_active = /** @type {((inputs?: Packaging_Material_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_active(inputs)
});